import { observable, runInAction, makeObservable } from 'mobx';

import { primitive, createModelSchema } from 'serializr';

export class Coords {
    lat: number | null = null;
    lon: number | null = null;

    constructor(lat?: number, lon?: number) {
        makeObservable(this, {
            lat: observable,
            lon: observable
        });

        if (lat && lon) {
            runInAction(() => {
                this.lat = lat;
                this.lon = lon;
            });
        }
    }
}

createModelSchema(Coords, {
    lat: primitive(),
    lon: primitive()
});
